import { z } from 'zod';
import i18next from '@/lib/i18n';

/**
 * Client-side validation schemas for bulk initialization
 * These match the backend contract schemas
 *
 * Factory functions are used to ensure validation messages
 * are translated at validation time, not at import time
 */

/**
 * Create a department schema with translated error messages
 * Factory function ensures messages are translated at validation time
 */
export function createDepartmentSchema() {
  return z.object({
    name: z.string().min(1, i18next.t('bulkOnboarding.validation.nameRequired')),
    description: z.string().optional(),
    abbreviation: z.string().min(1, i18next.t('bulkOnboarding.validation.abbreviationRequired')),
    parentAbbr: z.string().optional(),
    // Empty: saved without a manager hint, offen in Manager auflösen.
    managerEmail: z.email(i18next.t('bulkOnboarding.validation.invalidEmail')).or(z.literal(''))
  });
}

// Type exports derived from schemas
export type DepartmentInput = z.infer<ReturnType<typeof createDepartmentSchema>>;
